

<template>
  <div>
    <div class="content">
      <div class="content-inner">
        <order-content buttonName="确认下单" @response="orderPay" :order="order"  :showpromotion="false" :productInfo="productInfo" :showButton = "showButton">
          <div class="list-block media-list" style="margin-top: 0;width: 95%; padding: 0 0 0 5%;margin-bottom: 5px">
            <ul>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title-row">
                    <div class="item-title" style="padding-left: 0.5rem">订单编号</div>
                    <div class="item-after" style="padding-right: 0.5rem;">{{order.orderNo}}</div>
                  </div>

                  <div class="item-title-row">
                    <div class="item-title"  style="padding-left: 0.5rem">下单时间</div>
                    <div class="item-after" style="padding-right: 0.5rem;">{{order.createOrderDT}}</div>
                  </div></div></div>
            </ul>
          </div>

          <div class="list-block media-list" style="margin-top: 0px;margin-bottom: 0px">
            <div class="list-block media-list" style="margin-top: 1px;margin-bottom:2px;">
              <ul>
                <div class="innviceContent">付款方式</div>
                <!--线下支付(发票报账)-->
                <div class="item-media" style="height:2rem;">
                  <label class="label-checkbox">
                    <input type="radio" name="my-radio" :value="emkt.PAY_TYPE_FAPIAO" v-model="selectedPayType" checked>
                    <div class="item-media">
                      <i class="icon icon-form-checkbox"></i>
                      <span class="textContent"> 发票报账</span>
                    </div>
                  </label>
                  <p><a class="alert-text" @click="displayMessage(3)">

                    <img :src="questionUrl" style="width: .9rem"></img>

                  </a></p>
                </div>
                <!--余额支付-->
                <div class="item-media" style="height:2rem;">
                  <label class="label-checkbox">
                    <input type="radio" name="my-radio"v-model="selectedPayType" :value="emkt.PAY_TYPE_REMAIN_MONEY" >
                    <div class="item-media">
                      <i class="icon icon-form-checkbox"></i>
                      <span class="pay1 textContent">账户余额支付</span>
                    </div>

                  </label>
                  <p><a class="alert-text" @click="displayMessage(1)">
                    <img :src="questionUrl" style="width: .9rem"></a></p>
                </div>
                <div class="innviceContent">结算账户</div>
                <div class="item-media" style="height:2rem;" v-for="(settlementAccount, index) in settlementAccountList">
                  <label class="label-checkbox">
                    <input type="radio" name="my-radio2" v-model="selectedBalanceType"  :id="index" :value="settlementAccount">
                    <div class="item-media">
                      <i class="icon icon-form-checkbox"></i>
                      <span class="textContent"> {{settlementAccount.settlementAccountName}}</span>
                    </div>
                  </label>
                  <p><a class="alert-text" @click="displayMessage(6)">
                      <img :src="questionUrl" style="width: .9rem"></a></p>
                </div>
                  <li>
                    <router-link class="item-link item-content" :to="{ name: 'invoiceTitle', params: {order: order}}">
                      <div class="innoviceTitle item-inner item-title-row">
                        <div class="item-title" style="font-size:.9rem;font-weight: bolder">发票抬头</div>
                        <div class="item-after">{{defaultTitle}}</div>
                      </div>
                    </router-link>
                  </li>
                <div class="innviceContent">发票内容</div>
                <div class="item-media">
                  <label class="label-checkbox">
                    <input type="radio" name="my-invoice" checked>
                    <div class="item-media" style="padding:0">
                      <i class="icon icon-form-checkbox"></i><span class="textContent">明细</span></div>
                  </label>
                </div>

                <div class="item-title-row payTitle">
                  <div class="item-title" style="padding-top: 0.4rem">发票寄送地址</div>
                  <div lass="item-after">
                    <div>
                      <label class="label-switch">
                        <input type="checkbox" checked v-model="defaultInvoiceAddress" @change="selectAddress" >
                        <div class="checkbox"></div>
                      </label>
                      <span>与收货地址相同</span>
                    </div>
                  </div>
                </div>

                <div v-show="!defaultInvoiceAddress">
                    <li v-for="(address, index) in invoiceAddress">
                      <router-link class="item-link item-content" :to="{ name: 'myInvoiceAddress', params: {order: order}}">
                        <div class="item-inner" style="padding: 0 0 0 2rem">
                          <div class="item-title-row">
                            <div class="item-title">{{address.consignee}}</div>
                          </div>
                          <div class="item-subtitle">{{address.expressMobile}}</div>
                          <div class="item-text">{{address.expressAddress}}</div>
                        </div>
                      </router-link>
                    </li>
                </div>

                <!--</div>-->
                <div class="innviceContent" style="border-top: 1px gainsboro solid;">配送方式</div>
                    <div class="item-media">
                      <label class="label-checkbox">
                        <input type="radio" name="my" checked>
                        <div class="item-media" style="padding:0">
                          <i class="icon icon-form-checkbox"></i><span class="textContent">顺丰快递</span></div>
                      </label>
                    </div>
              </ul>

            </div>
          </div>
        </order-content>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import orderContent from './child/Order.vue'
  import {mapState, mapMutations} from 'vuex'
  import emkt from '../../emkt'
  export default {
    mounted () {
      var self = this
      let invoiceTitle = this.sessionInfo.invoiceTitle
      if (invoiceTitle) {
        let defTitle = invoiceTitle.filter(function (item) {
          return item.isDefault === 1
        })
        if (defTitle.length > 0) {
          this.defaultTitle = defTitle[0].enterpriseName
          this.taxpayerIdentificationNo = defTitle[0].invoiceTaxRegNo
        }
      }
      this.sessionInfo.invoiceAddress.forEach(function (item) {
        if (item.isDefault) {
          self.invoiceAddress.push(item)
          self.defaultInvoiceAddress = false
        }
      })
      // // 获取所有有效的任职关系列表，选择任职关系初始默认值
      // this.workExperienceList = emkt.getLocalStorage('EmktWorkExperienceList')
      // if (this.workExperienceList && this.workExperienceList.length > 0) {
      //   this.workExperienceNameList = this.workExperienceList.map(work => {
      //     return work.firstLevelEnterpriseName + (work.secondLevelEnterpriseName ? work.secondLevelEnterpriseName : '')
      //   })
      // } else {
      //   // 如果该客户无任职关系信息，取客户的个人信息中的单位信息
      //   const customerInfo = this.sessionInfo.customerInfo
      //   if (customerInfo && customerInfo.enterpriseNo) {
      //     const enterprise = {
      //       firstLevelEnterpriseNo: customerInfo.enterpriseNo,
      //       firstLevelEnterpriseName: customerInfo.enterpriseName
      //     }
      //     this.workExperienceList = [enterprise]
      //     this.workExperienceNameList = [customerInfo.enterpriseName]
      //   }
      // }
      // if (this.workExperienceNameList.length > 1) {
      //   this.ifNeedChooseWorkExperience = true
      // } else {
      //   this.ifNeedChooseWorkExperience = false
      // }
      // this.chosenWorkExperienceName = this.workExperienceNameList[0]
      // this.chosenWorkExperience = this.workExperienceList[0]
      // console.log('nameList', this.researchGroupSet, this.researchGroupNameList, this.workExperienceList, this.workExperienceNameList)
      // if (this.payType === 3 && this.ifNeedChooseWorkExperience) {
      //   this.showOptionList('workExperience', 0)
      // }
    },
    created () {
      if (this.sessionInfo.customerInfo && (this.sessionInfo.customerInfo.payTypeID === 1 ||
          this.sessionInfo.customerInfo.payTypeID === 3)) {
        this.isCredit = true
      }
      this.storedchoosedisplay = false
      this.customerNo = this.sessionInfo.customerInfo.customerNo
      this.getResearchGroupAndWorkExperience(this.customerNo)
    },
    components: {
      orderContent
    },
    data () {
      return {
        orderList: [],
        limitNum: 1,
        totalMoney: 0,
        order: this.$route.params.order,
        oldorder: {},
        payType: '3',
        defaultTitle: '',
        invoiceAddress: [],
        defaultInvoiceAddress: true,
        isCredit: false,
        taxpayerIdentificationNo: '',
        questionUrl: '/emktResources/resocurces/img/question.png',
        productInfo: {value: {}},
        showButton: true,
        veriCode: '',
        customerNo: '',
        coolDown: false,
        mobile: '',
        vipyanzheng: false,
        storedchoosedisplay: false,
        ifcanUseVipPlan: false,
        customerStoredPlanNo: '',
        planCustomerNo: '',
        vipPLan: [
          {
            vipguid: '1',
            checked: true
          },
          {
            vipguid: '2',
            checked: false
          }
        ],
        newgoodsMoney: 0,
        yueyanzheng: false,
        researchGroupNameList: [],
        chosenResearchGroupName: '',
        workExperienceNameList: [],
        chosenWorkExperienceName: '',
        workExperienceList: [],
        chosenWorkExperience: {},
        ifNeedChooseWorkExperience: false,
        saveItemInOrder: {
          0: 'workExperience',
          1: 'researchGroup'
        },
        yfukuanmoney: false,
        selectedBalanceType: emkt.BALANCE_TYPE_CUSTOMER,
        selectedPayType: emkt.PAY_TYPE_FAPIAO,
        chosenSettlementAccount: null,
        settlementAccountList: [],
        payTypeOptionMapping: {
          '1': 2,
          '3': 0,
          '6': 3,
          '7': 4
        }
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    watch: {
      'selectedPayType': {
        handler: 'handlePayTypeChange'
      },
      'selectedBalanceType': {
        handler: 'handleBalanceTypeChange'
      }
    },
    methods: {
      ...mapMutations([
        'MYORDER_UPDATE'
      ]),
      fetchData () {

      },
      getResearchGroupAndWorkExperience (customerNo) {
            // 获取所有的课题组信息
        this.gcapi('getSettlementAccountListInfo', customerNo).then(res => {
          if (res.body.result) {
            this.settlementAccountList = res.body.result
            if (!this.settlementAccountList || this.settlementAccountList.length === 0) {
              $.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
              return
            }
                    // 选择第一个正常的课题组为默认课题组
            for (let i = 0; i < this.settlementAccountList.length; i++) {
              if (this.settlementAccountList[i].settlementAccountStatus === emkt.SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
                this.chosenSettlementAccount = this.settlementAccountList[i]
                this.selectedBalanceType = this.chosenSettlementAccount
                break
              }
            }
            if (this.chosenSettlementAccount == null) {
              $.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
            }
          }
          this.calculatePriceByAccountDiscountRatio(this.customerNo)
        })
      },
      getOptionListHtml (optionList, optionName) {
        const className = 'radio-input-attr'
        var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' +
          '<input type="radio"  class="' + className + '" name="attr" value="'
        var ret2 = ''
        var ret3 = '" ><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">'
        var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">'
        let height = ''
        var length = 0
        let chosenValue = optionName === 'research' ? this.chosenResearchGroupName : this.chosenWorkExperienceName
        for (var i = 0; i < optionList.length; i++) {
          let name = optionList[i]
          if (chosenValue === name) {
            ret2 += ret1 + name + '" id="' + i + ret4 + name + '</div></div></label></li>'
          } else {
            ret2 += ret1 + name + '" id="' + i + ret3 + name + '</div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        return ret
      },
      showOptionList (optionName, chooseIndex) {
        if (optionName !== 'research' && this.ifNeedChooseWorkExperience === false) {
          console.log('不需要选择任职关系')
          if (chooseIndex === 2) {
            this.payByRestMoney(true)
          }
          return
        }
        let optionList = optionName === 'research' ? this.researchGroupNameList : this.workExperienceNameList
        let title = optionName === 'research' ? '请选择课题组' : '请选择您目前的任职信息'
        let error = optionName === 'research' ? '您尚未添加过课题组' : ''
        if (optionList.length === 0) {
          if (error) {
            $.alert(error)
          }
          return
        }
        $.modal({
          title: title,
          afterText: this.getOptionListHtml(optionList, optionName),
          buttons: [
            {
              text: '关闭',
              bold: true,
              onClick: () => {
              }
            }
          ]
        })
        const self = this
        $('.radio-input-attr').on('click', function (e) {
          e.preventDefault()
          if (optionName === 'research') {
            // debugger
            let id = $(this).attr('id')
            const chosenName = self.researchGroupNameList[id]
            console.log('radio id', id)
            if (self.researchGroupSet[id].status === emkt.RESEARCH_GROUP_STATUS_DISABLE) {
              return $.alert(chosenName + '未启用，请选择其他课题组')
            }
            if (self.researchGroupSet[id].status === emkt.RESEARCH_GROUP_STATUS_LOCKED) {
              return $.alert(chosenName + '已被冻结，请联系业务员解锁')
            }
            if (self.researchGroupSet[id].status === emkt.RESEARCH_GROUP_STATUS_EXPIRED) {
              return $.alert(chosenName + '已过期，请选择其他课题组')
            }
            let val = $(this).val()
            console.log('click', val)
            $.closeModal()
            $.toast('您已选择' + val)
            self.chosenResearchGroupName = val
            self.updateChoice(optionName)
            if (chooseIndex === 4) {
              let val = $(this).val()
                // debugger
              console.log('click', val)
              $.closeModal()
              if (chooseIndex === 2 || chooseIndex === 4) {
                self.payByRestMoney(false)
              }
            }
            self.calculatePriceByAccountDiscountRatio(self.customerNo)
          } else {
            let val = $(this).val()
            // debugger
            console.log('click', val)
            $.closeModal()
            self.chosenWorkExperienceName = val
            self.updateChoice(optionName)
            if (chooseIndex === 2) {
              self.payByRestMoney(true)
            }
          }
        })
      },
      updateChoice (optionName) {
        if (optionName === 'research' && this.chosenResearchGroupName) {
          const index = this.researchGroupNameList.indexOf(this.chosenResearchGroupName)
          if (index !== -1) {
            console.log('chosenReseachGroup', this.chosenResearchGroupName, this.researchGroupSet[index])
            this.chosenResearchGroup = this.researchGroupSet[index]
          }
        }
        if (optionName !== 'research' && this.chosenWorkExperienceName) {
          const index = this.workExperienceNameList.indexOf(this.chosenWorkExperienceName)
          if (index !== -1) {
            console.log('chosenWorkExperience', this.workExperienceList[index])
            this.chosenWorkExperience = this.workExperienceList[index]
          }
        }
      },
      selectAddress () {
        if (!this.defaultInvoiceAddress) {
          this.$router.push({name: 'myInvoiceAddress', params: {order: this.order}})
        }
      },
      yanzheng (optionIndex) {
        $.each(this.vipPLan, function (index, item) {
          item.checked = false
        })
        this.vipyanzheng = false
        this.vipPLan[optionIndex].checked = true
        var _this = this
        let radio = document.getElementsByName('my-radio')
        for (let i = 0; i < radio.length; i++) {
          if (radio[i].checked) {
            _this.payType = radio[i].value
          }
        }
        var div = ' <div class="item-content"> ' + ' <div class="item-inner"> ' + ' <div class="item-title label" style="margin-bottom: 10px">向管理员发送短信验证码</div> ' + ' <div class="item-input" style="display: inline-block"> ' + ' <input  id="veriCode" style="width:6rem;display: inline;" type="text" pattern="[0-9]*" v-model.trim="veriCode" placeholder="验证码"> ' + ' <div style="display: inline;width: 2.5rem"> ' + ' <a   id="sendcode" >发送</a> </div> </div> </div> </div> '
        $.modal({
          afterText: div,
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
              }
            },
            {
              text: '确定',
              bold: true,
              onClick: function () {
                var param = {
                  'LoginId': _this.mobile,
                  'VerifyCode': $('#veriCode').val()
                }
                _this.gcapi('gcwwwifc/verifyCustomerCode', param).then((response) => {
                  if (response.body.code === 0) {
                    alert(response.body.message)
                    _this.customerStoredPlanNo = _this.vipPLan[optionIndex].GUID
                    _this.vipyanzheng = true
                    _this.gcapi('retrieveCustomerPlanMemberInformation', _this.vipPLan[optionIndex].GUID).then((response) => {
                      var data = response.body.result
                      for (var i in data) {
                        if (data[i].role === 1) {
                          _this.mobile = data[i].mobile
                          let bOrders = []
                          let invoiceAddress
                          let invoiceExpressContactor
                          let invoiceExpressAddress
                          let invoiceExpressPhone
                          if (!_this.defaultInvoiceAddress) {
                            invoiceAddress = _this.invoiceAddress
                          } else {
                            invoiceAddress = _this.sessionInfo.expressAddress.filter(function (item) {
                              return item.isDefault === 1
                            })
                          }
                          if (invoiceAddress && invoiceAddress.length > 0) {
                            let invoice = invoiceAddress[0]
                            invoiceExpressContactor = invoice.consignee
                            invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress
                            invoiceExpressPhone = invoice.expressMobile
                          }
                          console.log(_this.customerStoredPlanNo)
                          let bOrder = {
                            payType: _this.payType,
                            id: _this.order.id,
                            invoiceTitle: _this.defaultTitle,
                            taxpayerIdentificationNo: _this.taxpayerIdentificationNo,
                            invoiceExpressContactor: invoiceExpressContactor,
                            invoiceExpressAddress: invoiceExpressAddress,
                            invoiceExpressPhone: invoiceExpressPhone,
                            prepayCustomerNo: _this.customerNo,
                            customerStoredPlanNo: _this.vipPLan[optionIndex].GUID
                          }
                          if (bOrder.payType === '5') {
                            bOrder.prepayCustomerNo = data[i].customerPlanMemberNo
                            _this.customerNo = data[i].customerPlanMemberNo
                          }
                          bOrder.amplification = _this.order.amplification
                          bOrders.push(bOrder)
                          var obj = {}
                          obj.bOrders = bOrders
                          obj.customerNo = data[i].customerPlanMemberNo
                          _this.gcapi('calculatePriceByAccountDiscountRatio', obj).then((response) => {
                            if (response.body.result !== null && response.body.result.length > 0) {
                              if (_this.order.merchandises.length === 1) {
                                _this.order.merchandises[0].price = response.body.result[0].price
                                _this.order.merchandises[0].discountPrice = response.body.result[0].discountPrice
                                _this.order.price = response.body.result[0].price
                                _this.order.totalPrice = response.body.result[0].totalPrice
                                _this.order.discountPrice = response.body.result[0].discountPrice
                              } else {
                                var price = 0
                                var totalPrice = 0
                                var discountPrice = 0
                                var initPrice = 0
                                if (_this.order.subOrders.length > 0) {
                                  for (var i = 0; i < response.body.result[0].subOrders.length; i++) {
                                    for (var j = 0; j < _this.order.subOrders.length; j++) {
                                      if (response.body.result[0].subOrders[i].id === _this.order.subOrders[j].id) {
                                        price = price + response.body.result[0].subOrders[i].price
                                        initPrice = initPrice + response.body.result[0].subOrders[i].initPrice
                                        totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice
                                        discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice
                                        if (!_this.order.subOrders[j].isStock) {
                                          _this.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price
                                          _this.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice
                                          _this.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice
                                        }
                                      }
                                    }
                                  }
                                } else {
                                  for (var m = 0; m < response.body.result[0].subOrders.length; m++) {
                                    for (var n = 0; n < _this.order.merchandises.length; n++) {
                                      if (response.body.result[0].subOrders[m].id === _this.order.merchandises[n].orderGuid) {
                                        if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                                          for (var o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                                            if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === _this.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                                              price = price + response.body.result[0].subOrders[m].stocks[o].price
                                              initPrice = initPrice + response.body.result[0].subOrders[m].stocks[o].initPrice
                                              totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[o].totalPrice
                                              discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[o].discountPrice
                                            }
                                          }
                                        } else {
                                          if (_this.order.merchandises[n].presentQuantity === 0) {
                                            price = price + response.body.result[0].subOrders[m].price
                                            initPrice = initPrice + response.body.result[0].subOrders[m].initPrice
                                            totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice
                                            discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
                                          }
                                        }
                                        if (_this.order.merchandises[n].categoryId === 20) {
                                          _this.order.merchandises[n].price = response.body.result[0].subOrders[m].price
                                          _this.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].initPrice
                                          _this.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].discountPrice
                                        }
                                      }
                                    }
                                  }
                                }
                                _this.order.price = price
                                _this.order.totalPrice = totalPrice
                                _this.order.initPrice = initPrice
                                _this.order.discountPrice = discountPrice
                              }
                            }
                          })
                        }
                      }
                    })
                  } else {
                    alert(response.body.message)
                  }
                })
              }
            }
          ]
        })
        $('#sendcode').on('click', function () {
          _this.sendVeriCode(optionIndex)
        })
      },
      choosevip (index) {
        this.customerNo = this.sessionInfo.customerInfo.customerNo
        console.log(this.payType)
        switch (index) {
          case 1:
            this.storedchoosedisplay = true
            break
          case 0:
            if (this.ifNeedChooseWorkExperience) {
              $('.all-pop-bg').show().find('.choose-workexperience').show() // 发票付款
            } else {
              console.log('unneccessary to choose work experience')
            }
            this.storedchoosedisplay = false
            this.calculatePriceByAccountDiscountRatio(this.customerNo)
            break
          case 2:
            if (this.ifNeedChooseWorkExperience) {
              $('.all-pop-bg').show().find('.choose-workexperience').show() // 余额付款 更新选择的任职经历后，调用payByRestMoney
            } else {
              console.log('unneccessary to choose work experience')
              this.payByRestMoney(true)
            }
            this.storedchoosedisplay = false
            this.yueyanzheng = false
            break
          case 4:
            this.payByRestMoney(true)
            this.storedchoosedisplay = false
            this.yueyanzheng = false   // 课题组余额
            break
          case 3:
                    // 选择课题组结算发票报账
            this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo)
            break
        }
      },
      getOrderpayType () {
        console.log('selectedBalanceType', this.selectedBalanceType)
            // 个人发票支付
        if (this.selectedBalanceType === emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_FAPIAO) {
          return '3'
        }
            // 个人余额支付
        if (this.selectedBalanceType === emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
          return '1'
        }
            // 课题组结算（发票报账）
        if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_FAPIAO) {
          return this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '6' : '3'
        }
            // 课题组结算（余额支付）
        if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
          return this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '7' : '1'
        }
      },
      handlePayTypeChange () {
        this.updateBalanceAccount()
        console.log('handlePayTypeChange', this.selectedPayType)
            // if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
            //   this.payByRestMoney()
            // } else {
            //   $('.all-pop-bg').show().find('.authCode').hide()
            //   $('.all-pop-bg').show().find('.vip-plan').hide()
            //   $('.all-pop-bg').show().find('.paid-over').show()
            // }
      },
      updateBalanceAccount () {
        this.payType = this.getOrderpayType()
        this.choosevip(this.payTypeOptionMapping[this.payType])
      },
      handleBalanceTypeChange () {
        if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER) {
          let chosenName = this.selectedBalanceType.settlementAccountName
          if (this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            let status = this.selectedBalanceType.settlementAccountStatus
            if (status !== emkt.SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
              this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
              this.$weui.alert(chosenName + '已冻结，请联系业务员解锁')
              return
                        // return alert(chosenName + '未启用，请选择其他课题组')
            }
            let researchGroupStatus = this.selectedBalanceType.researchGroupStatus
            if (!this.checkResearchGroup(researchGroupStatus, chosenName)) {
              return
            }
            this.chosenSettlementAccount = this.selectedBalanceType
            $.toast('您已选择' + chosenName, 1500)
          } else {
            this.chosenSettlementAccount = this.selectedBalanceType
            $.toast('您已选择' + chosenName, 1500)
          }
        } else {
          this.chosenSettlementAccount = null
        }
        this.updateBalanceAccount()
      },
      checkResearchGroup (researchGroupStatus, chosenName) {
        if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_DISABLE) {
          this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
          this.$weui.alert(chosenName + '课题组未启用，请选择其他结算账户')
          return false
              // return alert(chosenName + '未启用，请选择其他课题组')
        }
        if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_LOCKED) {
          this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
          this.$weui.alert(chosenName + '课题组已冻结，请联系业务员解锁')
          return false
              // return alert(chosenName + '未启用，请选择其他课题组')
        }
        if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_EXPIRED) {
          this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
          this.$weui.alert(chosenName + '课题组已过期，请选择其他结算账户')
          return false// return alert(chosenName + '未启用，请选择其他课题组')
        }
        return true
      },
      payByRestMoney (calculateprice) {
        console.log('prepay')
        this.storedchoosedisplay = false
        this.yueyanzheng = false
        var self = this
        if (self.sessionInfo.customerInfo.restPayCustomerNo === undefined || self.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
          $.modal({
            text: '<div style="margin-top: .5rem">余额客户名称</div><input id="customername" type="text" style="margin: .5rem 0 .7rem 0"></input></br>' +
            '余额客户手机号<input id="phoneNum" type="text" style="margin: .5rem 0 .5rem 0"></input><div id="appender"></div>',
            buttons: [{
              text: '提交',
              close: true,
              onClick: function () {
                let myreg = /^(1[34578]\d{9})$/
                let mobile = $('#phoneNum').val().match(/\d+(.\d+)?/g) + ''
                if (!myreg.test(mobile)) {
                  var colors = ['2px solid #f00', '']
                  // 设置闪烁间隔
                  var frequency = 100
                  var duration = 800
                  var i = 0
                  var timer = setInterval(function () {
                    $('#phoneNum').css('border', colors[i % colors.length])
                    if (i++ > colors.length) i = 0
                  }, frequency)
                  setTimeout(function () {
                    clearInterval(timer)
                  }, duration)
                  return false
                } else {
                  self.gcapi('gcwwwifc/verifyPrepayCustomer', {
                    'CustomerName': $.trim($('#customername').val()),
                    'Mobile': mobile
                  }).then((response) => {
                    let customerNo = response.body.result
                    if (customerNo) {
                      self.customerNo = customerNo
                      if (calculateprice) {
                        self.calculatePriceByAccountDiscountRatio(customerNo)
                      }
                    } else {
                      $.modal({
                        title: '绑定余额账号',
                        text: '<div style="margin: 1rem 0 0 -1.4rem">手机号<input id="phone" type="text" ' +
                        'style="width: 6rem;background-color: gainsboro; margin-left: .5rem"  disabled /></div></br>' +
                        '验证码<input id="verifyNum" type="text" style="width: 5rem;margin: .3rem .3rem 0 .7rem"></input> ' +
                        '<a id="enterBtn">发送</a><br/>' +
                        '<div id="appender" style="padding-top:.5rem;text-align: center;color: #999; font-size:smaller"></div>',
                        close: false,
                        buttons: [{
                          text: '提交',
                          close: false,
                          onClick: function () {
                            self.gcapi('gcwwwifc/confirmPrepayCustomer', {
                              'Mobile': mobile,
                              'VerifyCode': $('#verifyNum').val()
                            }).then((response) => {
                              if (response.body.code !== 0) {
                                $('#appender')[0].innerHTML = '验证码错误~'
                                return
                              }
                              let customerNo = response.body.result
                              if (customerNo) {
                                self.customerNo = customerNo
                              }
                              $.toast('提交成功')
                              if (calculateprice) {
                                self.calculatePriceByAccountDiscountRatio(customerNo)
                              }
                            })
                          }
                        }, {
                          text: '关闭'
                        }]
                      })
                      $('#phone').val($('#phoneNum').val())

                      $('#enterBtn').click(function () {
                        self.gcapi('gcwwwifc/applyPrepayCustomer', {
                          'Mobile': mobile
                        })
                        let wait = 60
                        function time (o) {
                          if (wait === 0) {
                            o.innerHTML = '发送'
                            o.style.color = ''
                            wait = 60
                          } else {
                            o.innerHTML = wait + 's'
                            o.style.color = '#C8C8C8'
                            wait--
                            setTimeout(function () {
                              time(o)
                            }, 1000)
                          }
                        }
                        time($('#enterBtn')[0])
                      })
                    }
                  })
                }
              }
            }, {
              text: '关闭'
            }]
          })
        } else {
          self.customerNo = self.sessionInfo.customerInfo.customerNo
          if (calculateprice) {
            self.calculatePriceByAccountDiscountRatio(self.customerNo)
          }
        }
      },
      sendVeriCode (optionIndex) {
        let _this = this
        _this.customerStoredPlanNo = ''
        if (!_this.coolDown) {
          _this.gcapi('retrieveCustomerPlanMemberInformation', _this.vipPLan[optionIndex].GUID).then((response) => {
            var data = response.body.result
            for (var i in data) {
              if (data[i].role === 3) {
                _this.mobile = data[i].mobile
                break
              }
            }
          }).then((reponse) => {
            if (_this.mobile === '' || _this.mobile === undefined) {
              alert('请配置管理联系人联系方式，否则无法进行验证！')
              return
            }
            console.log(_this.mobile)
            _this.gcapi('gcwwwifc/requestPasswordChange', {'LoginId': _this.mobile.replace(/\s+/g, '')}).then((response) => {
              _this.coolDown = true
              time(document.getElementById('sendcode'))
              alert(response.body.message)
            }, (response) => {
              alert(response.body.message)
            })
          })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      goToGoodsDetail () {
        this.$router.push({name: 'orderContentDetail', query: {order: this.order}})
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        let message
        switch (val) {
          case 1:
            message = '订单提交后，将使用您的账户余额支付订单货款。余额不足时，请选择其他支付方式。' +
              '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。'
            break
          case 3:
            message = '订单提交后，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。' +
              '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。'
            break
          case 4:
            message = '该订单包含【第三方】商品，此商品不支持余额付款。' +
              '请您使用线下付款或者将【第三方】商品与【自营】商品分开购买！'
            break
          case 5:
            message = '订单提交后，将使用您的蓝V储值账户余额支付订单货款。余额不足时，' +
              '请选择其他支付方式。为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人蓝V储值账户余额，' +
              '请准确填写储值帐号的姓名和手机号码进行授权。'
            break
          case 2:
            message = '订单提交后，将使用您的信用支付额度支付订单货款。信用支付额度不足时，请选择其他支付方式。' +
              '同时，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。货款到位后，您的账户将恢复相应信用支付额度。' +
              '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。'
            break
          case 6:
            message = '订单提交后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。'
            break
          case 7:
            message = '订单提交后，将计入您所在课题组的消费。同时订单货款将使用您的账户余额支付。余额不足时，请选择其他支付方式。' +
                    '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。'
        }
        $.alert(message)
      },
      orderPay () {
        let saveItemInOrderKey = 0
        let convertedPayType = this.payType
        if (this.chosenSettlementAccount === null) {
          this.$weui.alert('请选择结算账户')
          return
        }
        // 其余结算方式需要保存任职关系
        if (this.payType !== '6' && this.payType !== '7') {
          saveItemInOrderKey = 0
          console.log('this chosenwork', this.chosenWorkExperience)
        }
        // 课题组结算需要保存课题组信息
        if (this.payType === '6') {
          this.payType = '3'        // 课题组结算属于发票付款
          saveItemInOrderKey = 1
          console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
        }
        if (this.payType === '7') {
          this.payType = '1'        // 课题组结算属于发票付款
          saveItemInOrderKey = 1
          console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
          if (!this.yfukuanmoney) {
            return
          }
        }
        if (this.payType !== '5') {
          this.customerStoredPlanNo = ''
        }
        if (this.payType === '5' && this.vipyanzheng === false) {
          alert('使用大客户储值计划账户必须先验证，请您先验证！')
          return
        }
        if (this.payType === '1') {
          //  if (this.order.merchandises.length > 0) {
          //    for (let i in this.order.merchandises) {
          //      if (this.order.merchandises[i].selfOperated === 0) {
          //        this.displayMessage(4)
          //        return
          //      }
          //    }
          //  } else {
          //    for (let i in this.order.subOrders) {
          //      for (let j in this.order.subOrders[i].merchandises) {
          //        if (this.order.subOrders[i].merchandises[j].selfOperated === 0) {
          //          this.displayMessage(4)
          //          return
          //        }
          //      }
          //    }
          //  }
          if (this.checkInfo()) {
            // this.remainPay( )
            if (!this.yueyanzheng && (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0)) {
              alert('使用余额付款必须先验证，请您先验证！')
              return
            } else {
              this.successPay(saveItemInOrderKey, convertedPayType)
            }
          }
        } else {
          if (this.checkInfo()) {
            this.successPay(saveItemInOrderKey, convertedPayType)
          }
        }
      },
      successPay (saveItemInOrderKey, convertedPayType) {
        console.log('saveItemInOrderKey', convertedPayType, saveItemInOrderKey)
        const saveItem = {}
        if (this.chosenSettlementAccount === null) {
          $.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
          return
        }
        saveItem.settlementAccountNo = this.chosenSettlementAccount.settlementAccountNo
        if (saveItemInOrderKey === 1 && JSON.stringify(this.chosenSettlementAccount) !== '{}') {
          saveItem.balanceType = 1   // 课题组结算
          saveItem.researchGroupApproveResult = 0 // 审批状态 不需要审批
          saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo
          saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName
          saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo
          saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName
          saveItem.researchGroupNo = this.chosenSettlementAccount.researchGroupNo
          saveItem.researchGroupName = this.chosenSettlementAccount.researchGroupName
        } else if (saveItemInOrderKey === 0 && JSON.stringify(this.chosenSettlementAccount) !== '{}') {
          saveItem.balanceType = 0   // 个人结算
          saveItem.researchGroupApproveResult = 0  // 审批状态 不需要审批
          saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo
          saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName
          saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo
          saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName
        }
        console.log('saveItem', saveItem)
        // return
        var self = this
        let bOrders = []
        let invoiceAddress
        let invoiceExpressContactor
        let invoiceExpressAddress
        let invoiceExpressPhone
        if (!this.defaultInvoiceAddress) {
          invoiceAddress = this.invoiceAddress
        } else {
          invoiceAddress = this.sessionInfo.expressAddress.filter(function (item) {
            return item.isDefault === 1
          })
        }
        if (invoiceAddress && invoiceAddress.length > 0) {
          let invoice = invoiceAddress[0]
          invoiceExpressContactor = invoice.consignee
          invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress
          invoiceExpressPhone = invoice.expressMobile
        }
        console.log(this.customerStoredPlanNo)
        let bOrder = {
          payType: this.payType,
          id: this.order.id,
          invoiceTitle: this.defaultTitle,
          taxpayerIdentificationNo: this.taxpayerIdentificationNo,
          invoiceExpressContactor: invoiceExpressContactor,
          invoiceExpressAddress: invoiceExpressAddress,
          invoiceExpressPhone: invoiceExpressPhone,
          prepayCustomerNo: this.customerNo,
          customerStoredPlanNo: this.customerStoredPlanNo
        }
        Object.assign(bOrder, saveItem)
        console.log('border', bOrder)
        bOrder.amplification = self.order.amplification
        bOrders.push(bOrder)
        this.$weui.loading('正在生成合同，请稍等')
        this.showButton = false
        let BOrders = {}
        this.gcapi('orderPay', bOrders).then(response => {
          if (response.body.code === 1) {
            $.toast(response.body.message)
            return
          }
          BOrders = response.body.result
        }).then(function () {
          // $.hidePreloader()
          self.$weui.loading().hide()
          var failed = false
          for (var order in BOrders) {
            if (BOrders[order].status === 12) {
              failed = true
              continue
            }
          }
          if (failed) {
            alert('您参与的秒杀促销活动已经结束，此订单已自动取消，请您重新下单！')
            self.gcapi('retrieveMyOrder').then((response) => {
              self.MYORDER_UPDATE(response.body.result)
            })
            self.$router.replace({name: 'cart'})
          } else {
            if (BOrders[0].researchGroupApproveResult === emkt.RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE) {
              alert('您的订单正在审批中，审批结果会通过吉凯公众号消息告知您')
            }
            self.$router.replace({name: 'successPay', query: {BOrders: BOrders, order: self.$route.params.order}})
          }
        })
      },
      remainPay () {
//        var self = this
        if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
          // 他人付款
//          $.modal({
//            text: '<div style="margin-top: .5rem">余额客户名称</div><input id="customername" type="text" style="margin: .5rem 0 .7rem 0"></input></br>' +
//            '余额客户手机号<input id="phoneNum" type="text" style="margin: .5rem 0 .5rem 0"></input><div id="appender"></div>',
//            buttons: [{
//              text: '提交',
//              close: false,
//              onClick: function () {
//                let myreg = /^(1[34578]\d{9})$/
//                let mobile = $('#phoneNum').val().match(/\d+(.\d+)?/g) + ''
//                if (!myreg.test(mobile)) {
//                  var colors = ['2px solid #f00', '']
//                  // 设置闪烁间隔
//                  var frequency = 100
//                  var duration = 800
//
//                  var i = 0
//                  var timer = setInterval(function () {
//                    $('#phoneNum').css('border', colors[i % colors.length])
//                    if (i++ > colors.length) i = 0
//                  }, frequency)
//                  setTimeout(function () {
//                    clearInterval(timer)
//                  }, duration)
//                  return false
//                } else {
//                  self.gcapi('gcwwwifc/verifyPrepayCustomer', {
//                    'CustomerName': $.trim($('#customername').val()),
//                    'Mobile': mobile
//                  }).then((response) => {
//                    let customerNo = response.body.result
//                    if (customerNo) {
//                      self.customerNo = customerNo
//                      self.successPay()
//                    } else {
//                      $.modal({
//                        title: '绑定余额账号',
//                        text: '<div style="margin: 1rem 0 0 -1.4rem">手机号<input id="phone" type="text" ' +
//                        'style="width: 6rem;background-color: gainsboro; margin-left: .5rem"  disabled /></div></br>' +
//                        '验证码<input id="verifyNum" type="text" style="width: 5rem;margin: .3rem .3rem 0 .7rem"></input> ' +
//                        '<a id="enterBtn">发送</a><br/>' +
//                        '<div id="appender" style="padding-top:.5rem;text-align: center;color: #999; font-size:smaller"></div>',
//                        close: false,
//                        buttons: [{
//                          text: '提交',
//                          close: false,
//                          onClick: function () {
//                            self.gcapi('gcwwwifc/confirmPrepayCustomer', {
//                              'Mobile': mobile,
//                              'VerifyCode': $('#verifyNum').val()
//                            }).then((response) => {
//                              if (response.body.code !== 0) {
//                                $('#appender')[0].innerHTML = '验证码错误~'
//                                return
//                              }
//                              let customerNo = response.body.result
//                              if (customerNo) {
//                                self.customerNo = customerNo
//                              }
//                              $.toast('提交成功')
//                              self.successPay()
//                            })
//                          }
//                        }, {
//                          text: '关闭'
//                        }]
//                      })
//                      $('#phone').val($('#phoneNum').val())
//
//                      $('#enterBtn').click(function () {
//                        self.gcapi('gcwwwifc/applyPrepayCustomer', {
//                          'Mobile': mobile
//                        })
//                        let wait = 60
//                        function time (o) {
//                          if (wait === 0) {
//                            o.innerHTML = '发送'
//                            o.style.color = ''
//                            wait = 60
//                          } else {
//                            o.innerHTML = wait + 's'
//                            o.style.color = '#C8C8C8'
//                            wait--
//                            setTimeout(function () {
//                              time(o)
//                            }, 1000)
//                          }
//                        }
//                        time($('#enterBtn')[0])
//                      })
//                    }
//                  })
//                }
//              }
//            }, {
//              text: '关闭'
//            }]
//          })
        } else {
          this.customerNo = this.sessionInfo.customerInfo.customerNo
          this.successPay()
        }
      },
      checkInfo () {
        if (this.defaultTitle === '') {
          $.toast('请选择发票抬头')
          return false
        } else {
          return true
        }
      },
      calculatePriceByAccountDiscountRatio (customerNo) {
        var self = this
        self.yueyanzheng = true
        let bOrders = []
        let invoiceAddress
        let invoiceExpressContactor
        let invoiceExpressAddress
        let invoiceExpressPhone
        if (self.chosenSettlementAccount === null) {
          return
        }
        if (!self.defaultInvoiceAddress) {
          invoiceAddress = self.invoiceAddress
        } else {
          invoiceAddress = self.sessionInfo.expressAddress.filter(function (item) {
            return item.isDefault === 1
          })
        }
        if (invoiceAddress && invoiceAddress.length > 0) {
          let invoice = invoiceAddress[0]
          invoiceExpressContactor = invoice.consignee
          invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress
          invoiceExpressPhone = invoice.expressMobile
        }
        let bOrder = {
          payType: self.payType,
          id: self.order.id,
          invoiceTitle: self.defaultTitle,
          taxpayerIdentificationNo: self.taxpayerIdentificationNo,
          invoiceExpressContactor: invoiceExpressContactor,
          invoiceExpressAddress: invoiceExpressAddress,
          invoiceExpressPhone: invoiceExpressPhone,
          prepayCustomerNo: self.customerNo,
          customerStoredPlanNo: self.customerStoredPlanNo
        }
        bOrder.amplification = self.order.amplification
        bOrders.push(bOrder)
        var obj = {}
        obj.settlementAccountNo = self.chosenSettlementAccount.settlementAccountNo
        obj.bOrders = bOrders
        obj.customerNo = customerNo
        // 计算折扣率时，传入结算方式和课题组编号
        if (self.payType === '6') {
          bOrder.payType = '3'
          if (self.chosenSettlementAccount.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            bOrder.balanceType = emkt.BALANCE_TYPE_RESEARCH_GROUP
            obj.researchGroupNo = self.chosenSettlementAccount.researchGroupNo
          } else {
            bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
          }
        } else if (self.payType === '7') {
          bOrder.payType = '1'
          if (self.chosenSettlementAccount.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            bOrder.balanceType = emkt.BALANCE_TYPE_RESEARCH_GROUP
          } else {
            bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
          }
        } else {
          bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
        }
        console.log('order', self.order)
        self.gcapi('calculatePriceByAccountDiscountRatio', obj).then((response) => {
          if (response.body.result !== null && response.body.result.length > 0) {
            if (bOrder.balanceType === 1 && bOrder.payType === '1') {
              var obj = {'customerNo': self.customerNo, 'price': response.body.result[0].price}
              self.gcapi('hasPrepayRemain', obj).then((response) => {
                if (!response.body.result) {
                  self.yfukuanmoney = false
                  alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
                } else {
                  self.yfukuanmoney = true
                }
              })
            }
            if (self.order.merchandises.length === 1) {
              self.order.merchandises[0].price = response.body.result[0].price
              self.order.merchandises[0].discountPrice = response.body.result[0].discountPrice
              self.order.price = response.body.result[0].price
              self.order.initPrice = response.body.result[0].initPrice
              self.order.totalPrice = response.body.result[0].totalPrice
              self.order.discountPrice = response.body.result[0].discountPrice
            } else {
              var price = 0
              var totalPrice = 0
              var initPrice = 0
              var discountPrice = 0
              if (self.order.subOrders.length > 0) {
                for (let i = 0; i < response.body.result[0].subOrders.length; i++) {
                  for (let j = 0; j < self.order.subOrders.length; j++) {
                    if (response.body.result[0].subOrders[i].id === self.order.subOrders[j].id) {
                      price = price + response.body.result[0].subOrders[i].price
                      initPrice = initPrice + response.body.result[0].subOrders[i].initPrice
                      totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice
                      discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice
                      if (!self.order.subOrders[j].isStock) {
                        self.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price
                        self.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice
                        self.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice
                      } else { // 增加现货折扣后价格
                        for (let n = 0; n < self.order.merchandises.length; n++) {
                          for (let o = 0; o < response.body.result[0].subOrders[i].stocks.length; o++) {
                            if (response.body.result[0].subOrders[i].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                              self.order.merchandises[n].price = response.body.result[0].subOrders[i].stocks[o].price
                              self.order.merchandises[n].initPrice = response.body.result[0].subOrders[i].stocks[o].initPrice
                              self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[i].stocks[o].discountPrice
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else if (response.body.result[0].subOrders.length > 0) {
                for (let m = 0; m < response.body.result[0].subOrders.length; m++) {
                  for (let n = 0; n < self.order.merchandises.length; n++) {
                    if (response.body.result[0].subOrders[m].id === self.order.merchandises[n].orderGuid) {
                      if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                        for (let o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                          if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                            price = price + response.body.result[0].subOrders[m].stocks[o].price
                            initPrice = initPrice + response.body.result[0].subOrders[m].stocks[o].initPrice
                            totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[o].totalPrice
                            discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[o].discountPrice
                          }
                        }
                      } else {
                        if (self.order.merchandises[n].presentQuantity === 0) {
                          price = price + response.body.result[0].subOrders[m].price
                          initPrice = initPrice + response.body.result[0].subOrders[m].initPrice
                          totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice
                          discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
                        }
                      }
//                      if (self.order.merchandises[n].isStock) {
//                        discountPrice = discountPrice + self.order.merchandises[n].discountPrice
//                      } else {
//                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
//                      }
                      if (self.order.merchandises[n].categoryId === 20) {
                        self.order.merchandises[n].price = response.body.result[0].subOrders[m].price
                        self.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].initPrice
                        self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].discountPrice
                      } else if (self.order.merchandises[n].presentQuantity === 0) {
                        // 现货更新商品价格
                        for (let o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                          if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                            self.order.merchandises[n].price = response.body.result[0].subOrders[m].stocks[o].price
                            self.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].stocks[o].initPrice
                            self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].stocks[o].discountPrice
                          }
                        }
                      }
                    }
                  }
                }
              } else { // 更新现货折扣后价格
                if (response.body.result[0].isStock && response.body.result[0].stocks.length > 0) {
                  for (let n = 0; n < self.order.merchandises.length; n++) {
                    for (let o = 0; o < response.body.result[0].stocks.length; o++) {
                      if (response.body.result[0].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                        price = price + response.body.result[0].stocks[o].price
                        initPrice = initPrice + response.body.result[0].stocks[o].initPrice
                        totalPrice = totalPrice + response.body.result[0].stocks[o].totalPrice
                        discountPrice = discountPrice + response.body.result[0].stocks[o].discountPrice

                        self.order.merchandises[n].price = response.body.result[0].stocks[o].price
                        self.order.merchandises[n].initPrice = response.body.result[0].stocks[o].initPrice
                        self.order.merchandises[n].discountPrice = response.body.result[0].stocks[o].discountPrice
                      }
                    }
                  }
                }
              }
              self.order.price = price
              self.order.totalPrice = totalPrice
              self.order.initPrice = initPrice
              self.order.discountPrice = discountPrice
            }
          }
        })
      },
      showResearchGroupIntro () {
        let info = '<div>为您的科研课题组创建专属账户，您可享受专属科研服务、更优的折扣活动、账户月结便捷跟踪管理。如果还未加入课题组计划，请联系我们的业务人员或致电<a href="tel:400-621-0302">400-621-0302</a></div>'
        $.modal({
          afterText: info,
          buttons: [
            {
              text: 'ok',
              bold: true,
              onClick: () => {
              }
            }
          ]
        })
      }
    }
  }
</script>

<style type="text/css" scoped>
  .payTitle {
    color: #00469A;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 0.2rem 0 0.2rem 1.9rem;
    border-top: 1px solid #e7e7e7;
  }
  .innviceContent {
    color: #00469A;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 0.2rem 0 0.2rem 1.9rem;
  }
  .innoviceTitle {
    color: #00469A;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 0.1rem 0 0.1rem 1.1rem;
    border-top: 1px solid #e7e7e7;
  }
  .item-media .label-checkbox {
    padding: 0 1rem 0 2rem;
  }

  .textContent {
    padding-left: 0.8rem;
  }

</style>



// WEBPACK FOOTER //
// OrderContent.vue?1600dea1